import {Component, OnInit} from "@angular/core";
import {UserService} from "../services/users.service";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpErrorResponse} from "@angular/common/http";
import {Auth2Service} from "../../../services/auth2.service";
import {ApiService} from "../../../services/api.service";
import {Title} from "@angular/platform-browser";
import {ConsultantDto} from "../../../models/consultant-dto";

@Component({
  selector: 'app-create-consultant-profile',
  templateUrl: './create-consultant-profile.component.html',
  styleUrls: ['./create-consultant-profile.component.scss'],
  standalone: false
})
export class CreateConsultantProfileComponent implements OnInit {
  breadCrumbs = [
    {iconClass: 'bi-house', path: 'https://www.scalanthropy.com/'},
    {label: 'Home', path: 'https://www.scalanthropy.com/'},
    {label: 'Login', path: '/app/login'},
    {label: 'Register Consultant Profile as Partner'}
  ];

  showMessages: boolean = false;
  messages: any[] = [];

  showSuccessMessages: boolean = false;
  successMessages: any[] = [];

  statesList: any[] = [];
  causeDropdownList: any[] = [];

  profileName = 'Create Consultant Profile for Approval';
  firstName: string = '';
  lastName: string = '';
  phoneNumber: string = '';
  email: string = '';
  savedEmail: string = '';
  ein: string = '999999999';
  companyName: string = '';
  //Physical Address for Stripe
  addressLine1: string = '';
  addressLine2: string = '';
  addressLine3: string = '';
  city: string = '';
  state: string = '';
  country: string = 'UNITED STATES';
  zipCode: string = '';
  jobTitle: string = '';
  termsAndConditionsRadioButton: boolean = false;

  showModalErrorMessages: boolean = false;
  modalErrorMessages: any = [];
  showModalSuccessMessages: boolean = false;
  modalSuccessMessages: any = [];

  clientEmailInvitationReminderModal: any = null;
  inviteEmailModalBtn1: any = null;
  closeModalBtn2: any = null;
  clientEmailInvitationCloseSpan: any = null;

  // @ts-ignore
  constructor(private userService: UserService,
              private router: Router,
              private route: ActivatedRoute,
              private auth2Service: Auth2Service,
              private apiService: ApiService,
              private titleService: Title) {
  }

  ngOnInit(): void {
    window.scrollTo({top: 0, left: 0, behavior: "smooth"})
    this.setUpClientInviteReminderModal();
    //this.populateUSAStates();
    this.titleService.setTitle("Scalanthropy Consultant Submission for Approval");
  }

  setUpClientInviteReminderModal(): void {
    // Get the modal
    this.clientEmailInvitationReminderModal = document.getElementById("client-email-invitation-reminder-modal-id");

    // Get the button that opens the modal
    // @ts-ignore
    this.inviteEmailModalBtn1 = document.getElementById("invite-email-modal-button1-id");
    this.closeModalBtn2 = document.getElementById("close-modal-button1-id");
    // Get the <span> element that closes the modal
    this.clientEmailInvitationCloseSpan = document.getElementsByClassName("close")[0] as HTMLElement;
  }

  toggleLegalAgreement(): void {
    this.termsAndConditionsRadioButton = !this.termsAndConditionsRadioButton;
  }

  checkoutSessionConsultantV3(): void {
    this.messages = [];

    this.userService.checkoutSessionConsultantV3SavePaymentMethodOnApproval(this.savedEmail)
      .subscribe((result: any) => {
        if (result && result.body && result.body.url) {
          //Checkout Started
          this.successMessages.push({
            field: 'Checkout Session',
            detail: 'Checkout Session Started.',
            severity: 'success'
          });
          this.showMessagesToUser();
          // @ts-ignore
          window.open(result.body.url, '_self');
        }
      }, (err1: HttpErrorResponse) => {
        if (err1.status == 400) {
          this.messages.push({
            field: 'Subscription Plan Promo Code Error',
            detail: err1.error.message + '. Your account though has been created. Redirecting to subscription selection.',
            severity: 'error'
          });
        } else {
          this.messages.push({
            field: 'Subscription Plan Checkout Session API Error',
            detail: 'Failed to create a checkout session. ' + err1.error.message + ' Your account though has been created. Redirecting to subscription selection.',
            severity: 'error'
          });
        }
        this.showMessagesToUser(8000);
        //Redirect to Subscription payments and checkout.
        this.router.navigateByUrl('app/users/dashboard/subscription/pricing/pay');
      });
  }

  populateUSAStates(): void {
    this.statesList = [];
    this.userService.getUSAStatesDropdown().subscribe((result: any) => {
      if (result && result.body) {
        let i: number = 0;
        while (i < result.body.length) {
          this.statesList.push(result.body[i]);
          i = i + 1;
        }
      }
    }, (error: HttpErrorResponse) => {
      console.log(error);
    })
  }

  onCancel(): void {
    this.router.navigateByUrl('app/login');
  }

  showMessagesToUser(delayTime: number = 8000): void {
    this.showMessages = true;
    const counterFn = () => {
      this.showMessages = false;
    }
    setTimeout(counterFn, delayTime);
  }

  showModalSuccessMessagesToUser(delayTime: number = 8000): void {
    this.showModalSuccessMessages = true;
    const counterFn = () => {
      this.showModalSuccessMessages = false;
    }
    setTimeout(counterFn, delayTime);
  }

  showModalErrorMessagesToUser(delayTime: number = 8000): void {
    this.showModalErrorMessages = true;
    const counterFn = () => {
      this.showModalErrorMessages = false;
    }
    setTimeout(counterFn, delayTime);
  }

  onSave(): void {
    this.showMessages = false;
    this.showSuccessMessages = false;
    this.messages = [];
    this.successMessages = [];
    //Validate First Name
    const firstNameEl = document.getElementById('first-name-text-id');
    // @ts-ignore
    let firstName = firstNameEl.value;
    if (!firstName) {
      this.messages.push({
        field: 'First Name',
        detail: 'First Name: ' + firstName + ' must not be empty.',
        severity: 'error'
      });
    }
    firstName = this.apiService.trimLeadingTrailingSpaces(firstName)
    if (firstName && firstName.length < 2 && firstName.length > 50) {
      this.messages.push({
        field: 'First Name',
        detail: 'First Name: ' + firstName + ' is not valid. The First Name must be 2 between 40 alphabetical characters, including dashes and spaces.',
        severity: 'error'
      })
    }
    this.firstName = firstName;

    //Validate Last Name
    const lastNameEl = document.getElementById('last-name-text-id');
    // @ts-ignore
    let lastName = lastNameEl.value;
    if (!lastName) {
      this.messages.push({
        field: 'Last Name',
        detail: 'Last Name: ' + lastName + ' must not be empty.',
        severity: 'error'
      })
    }
    lastName = this.apiService.trimLeadingTrailingSpaces(lastName);
    if (lastName && lastName.length < 2 && lastName.length > 50) {
      this.messages.push({
        field: 'Last Name',
        detail: 'Last Name: ' + lastName + ' is not valid. The Last Name must be 2 between 40 alphabetical characters, including dashes and spaces.',
        severity: 'error'
      })
    }
    this.lastName = lastName;

    //Validate email
    const emailEl = document.getElementById('email-text-id');
    // @ts-ignore
    const email = emailEl.value;
    if (!email) {
      this.messages.push({
        field: 'Email',
        detail: 'Email: ' + email + ' is not valid.',
        severity: 'error'
      })
    }
    this.email = this.apiService.trimLeadingTrailingSpaces(email);

    const confirmEmailEl = document.getElementById('confirm-email-text-id');
    // @ts-ignore
    const confirmEmail = confirmEmailEl.value;
    if (!confirmEmail) {
      this.messages.push({
        field: 'Confirm Email',
        detail: 'Confirm Email: ' + email + ' is not valid.',
        severity: 'error'
      })
    } else if (this.email != confirmEmail) {
      this.messages.push({
        field: 'Email Mismatch',
        detail: 'Emails: do NOT is not match.',
        severity: 'error'
      })
    }

    //Validate Phone Number
    const phoneNumberEl = document.getElementById('phone-number-text-id');
    // @ts-ignore
    const phoneNumber = phoneNumberEl.value;
    if (!phoneNumber) {
      this.messages.push({
        field: 'Phone Number',
        detail: 'Phone Number: ' + phoneNumber + ' must not be empty.',
        severity: 'error'
      })
    }
    let modPhoneNumber: string = phoneNumber.replaceAll("-", "");
    modPhoneNumber = modPhoneNumber.replaceAll(" ", "");
    modPhoneNumber = modPhoneNumber.replaceAll("(", "");
    modPhoneNumber = modPhoneNumber.replaceAll(")", "");
    if (modPhoneNumber && modPhoneNumber.length != 10) {
      this.messages.push({
        field: 'Phone Number',
        detail: 'Phone Number: ' + phoneNumber + ' is not valid. The Phone Number must be exactly 10 digits and must be a US phone number.',
        severity: 'error'
      })
    }
    this.phoneNumber = modPhoneNumber;

    //Validate Company Name
    const companyNameEl = document.getElementById('company-name-text-id');
    // @ts-ignore
    const companyName = companyNameEl.value;
    if (!companyName) {
      this.messages.push({
        field: 'Company Name',
        detail: 'Company Name: ' + companyName + ' is not valid.',
        severity: 'error'
      })
    } else {
      let companyNameTemp = companyName;
      companyNameTemp = this.apiService.trimLeadingTrailingSpaces(companyNameTemp)
      if (companyNameTemp.length < 2 && companyNameTemp.length > 100) {
        this.messages.push({
          field: 'Company Name',
          detail: 'Company Name: ' + companyNameTemp + ' 2 to 50 characters.',
          severity: 'error'
        });
      }
    }
    this.companyName = this.apiService.trimLeadingTrailingSpaces(companyName);

    //Validate Physical Address
    //Address Line 1
    /*
    const addressLine1El = document.getElementById('address-line-1-text-id');
    // @ts-ignore
    const addressLine1: string = addressLine1El.value;
    if (!addressLine1) {
      this.messages.push({
        field: 'AddressLine1',
        detail: 'AddressLine1: ' + addressLine1 + ' is not valid and must not be empty.',
        severity: 'error'
      })
    }
    this.addressLine1 = this.apiService.trimLeadingTrailingSpaces(addressLine1);*/
    this.addressLine1 = 'N/A';

    /*
    const addressLine2El = document.getElementById('address-line-2-text-id');
    // @ts-ignore
    const addressLine2: string = addressLine2El.value;
    this.addressLine2 = addressLine2*/
    this.addressLine2 = 'N/A';

    //const addressLine3El = document.getElementById('address-line-3-text-id');
    // @ts-ignore
    /*
    const addressLine3: string = '';
    this.addressLine3 = addressLine3*/
    this.addressLine3 = 'N/A';

    /*
    const cityEl = document.getElementById('city-text-id');
    // @ts-ignore
    const city = cityEl.value;
    if (!city) {
      this.messages.push({
        field: 'City',
        detail: 'City: ' + city + ' must not be empty.',
        severity: 'error'
      })
    }
    this.city = this.apiService.trimLeadingTrailingSpaces(city);*/
    this.city = 'N/A';

    /*
    const stateEl = document.getElementById('usa-dropdown-list-id');
    // @ts-ignore
    const state: string = stateEl.value;
    if (!state) {
      this.messages.push({
        field: 'State',
        detail: 'State: ' + state + ' must not be empty.',
        severity: 'error'
      })
    }
    this.state = this.apiService.trimLeadingTrailingSpaces(state);*/
    this.state = 'AR';
    /*
    const countryEl = document.getElementById('country-text-id');
    // @ts-ignore
    const country = countryEl.value;
    if (!country) {
      this.messages.push({
        field: 'Country',
        detail: 'Country: ' + country + ' must not be empty.',
        severity: 'error'
      })
    }*/

    /*
    const zipCodeEl = document.getElementById('zip-code-text-id');
    // @ts-ignore
    let zipCode: string = zipCodeEl.value;
    if (!zipCode) {
      this.messages.push({
        field: 'Zip Code',
        detail: 'Zip code: ' + zipCode + ' must not be empty.',
        severity: 'error'
      });
    } else {
      zipCode = zipCode.replace("-", "");
      zipCode = this.apiService.trimLeadingTrailingSpaces(zipCode)
      if (zipCode.length != 5 && zipCode.length != 9) {
        this.messages.push({
          field: 'Zip Code',
          detail: 'Zip code: ' + zipCode + ' can only be 5 digits or 9 digits.',
          severity: 'error'
        });
      }
    }
    this.zipCode = zipCode;*/
    this.zipCode = '99999';

    const jobTitleEl = document.getElementById('job-title-text-id');
    // @ts-ignore
    let jobTitleTemp: string = jobTitleEl.value;
    if (!jobTitleTemp) {
      this.messages.push({
        field: 'Job Title',
        detail: 'Job Title: ' + jobTitleTemp + ' must not be empty.',
        severity: 'error'
      });
    } else {
      jobTitleTemp = jobTitleTemp.replace("-", "");
      jobTitleTemp = this.apiService.trimLeadingTrailingSpaces(jobTitleTemp)
      if (jobTitleTemp.length < 2 && jobTitleTemp.length > 50) {
        this.messages.push({
          field: 'Job Title',
          detail: 'Job Title: ' + jobTitleTemp + ' must be 2 to 50 characters.',
          severity: 'error'
        });
      }
    }
    this.jobTitle = jobTitleTemp;

    if (!this.termsAndConditionsRadioButton) {
      this.messages.push({
        field: 'Legal Agreement',
        detail: 'You must agree to the Terms and Conditions.',
        severity: 'error'
      });
    }

    if (this.messages.length > 0 || !this.termsAndConditionsRadioButton) {
      this.showMessagesToUser();
      return;
    }

    let consultantDto: ConsultantDto = {
      "consultantId": -1,
      "firstName": this.firstName,
      "lastName": this.lastName,
      "email": this.email,
      "phoneNumber": this.phoneNumber,
      "companyName": this.companyName,
      "ein": this.ein,
      "jobTitle": this.jobTitle,
      "addressLine1": this.addressLine1,
      "addressLine2": this.addressLine2,
      "addressLine3": this.addressLine3,
      "city": this.city,
      "state": this.state,
      "country": this.country,
      "zipCode": this.zipCode,
      "approvedFlag": 'Y',
      "invitedByClientBeforeJoining": 'N'
    }

    //submit API
    this.successMessages = [];
    this.messages = [];
    this.successMessages.push({
      field: 'Consultant Profile Creation',
      detail: 'Consultant Profile Creation Started. Please wait.',
      severity: 'success'
    });
    this.showSuccessMessages = true;
    this.userService.createConsultantProfileV3(consultantDto).subscribe(
      (result: any) => {
        if (result && result.body) {
          this.savedEmail = result.body.email;
          localStorage.setItem('username', this.savedEmail);
          this.userService.createUserTermsAndConditionsLegalAgreement(this.savedEmail)
            .subscribe((result2: any) => {
              if (result2 && result2.body && result2.body.agreed) {
                //Legal Agreement Recorded
                this.successMessages.push({
                  field: 'Legal Agreement',
                  detail: 'Legal Agreement Successfully Recorded.',
                  severity: 'success'
                });
                //Checkout URL Link Generation Started
                this.successMessages.push({
                  field: 'Checkout URL Link',
                  detail: 'Checkout URL Link Generation Started.',
                  severity: 'success'
                });
                this.checkoutSessionConsultantV3();
              }
            }, (err2: HttpErrorResponse) => {
              this.messages.push({
                field: 'username / email',
                detail: 'Error creating Agreement Entry for Terms and Conditions for consultant email: ',
                severity: 'error'
              });
              this.showMessagesToUser();
            });

        }
      }, (error: HttpErrorResponse) => {
        this.messages.push({
          field: 'Consultant Profile Creation Failed',
          detail: 'Consultant Profile Creation Failed',
          severity: 'success'
        });
        this.showMessagesToUser();
      })

  }

  openInvitationModal(): boolean {
    // @ts-ignore
    this.clientEmailInvitationReminderModal.style.display = "block";
    return true;
  }

  closeInvitationReminderModal(): boolean {
    // @ts-ignore
    this.clientEmailInvitationReminderModal.style.display = "none";
    return true;
  }

  submitInvitationReminderToNonprofitClient(): void {
    this.modalSuccessMessages = [];
    this.showModalSuccessMessages = false;
    this.modalErrorMessages = [];
    this.showModalErrorMessages = false;
    const consultantEmailEl = document.getElementById('modal-consultant-email-text-id');
    // @ts-ignore
    const consultantEmail = consultantEmailEl.value;
    let finalConsultantEmail: any = null;
    if (!consultantEmail) {
      this.modalErrorMessages.push({
        field: 'Consultant Email Missing',
        detail: 'Consultant Email Missing',
        severity: 'error'
      });
    } else {
      if (consultantEmail.length >= 40) {
        this.modalErrorMessages.push({
          field: 'Consultant Email Too Long',
          detail: 'Consultant Email must be no longer than 40 characters',
          severity: 'error'
        });
      } else {
        finalConsultantEmail = this.apiService.trimLeadingTrailingSpaces(consultantEmail);
      }
    }

    const clientEmailEl = document.getElementById('modal-client-email-text-id');
    // @ts-ignore
    const clientEmail = clientEmailEl.value;
    let finalClientEmail: any = null;
    if (!clientEmail) {
      this.modalErrorMessages.push({
        field: 'Client Email Missing',
        detail: 'Client Email Missing',
        severity: 'error'
      });
    } else {
      if (clientEmail.length >= 40) {
        this.modalErrorMessages.push({
          field: 'Client Email Too Long',
          detail: 'Client Email must be no longer than 40 characters',
          severity: 'error'
        });
      } else {
        finalClientEmail = this.apiService.trimLeadingTrailingSpaces(clientEmail);
      }
    }
    if (this.modalErrorMessages.length > 0) {
      this.showModalErrorMessagesToUser();
      return;
    }

    this.userService.sendClientAnInvitationReminder(finalConsultantEmail, finalClientEmail).subscribe(
      (invitationResult: any) => {
        if (invitationResult && invitationResult.body) {
          this.modalSuccessMessages.push({
            field: 'Consultant to Client Email Reminder Success',
            detail: 'You have successfully reminded the client to invite for a referral code.',
            severity: 'success'
          });
          this.showModalSuccessMessagesToUser();
          this.closeInvitationReminderModal();
        }
      }, (errorResponse: HttpErrorResponse) => {
        this.modalErrorMessages.push({
          field: 'Consultant Profile Creation Failed',
          detail: 'Consultant Profile Creation Failed',
          severity: 'success'
        });
        this.showModalErrorMessagesToUser();
      }
    );
  }
}
